import * as React from 'react';
export default function ToolBar(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "tool-bar",
    style: props.style
  }, props.children);
}